import React from 'react';
import { IonChip, IonLabel } from '@ionic/react';
import { AllocationStatus } from '../../../../models';

const COLOR: Record<AllocationStatus, string> = {
    cancelled: 'danger',
    checkedIn: 'medium',
    confirmed: 'success',
    pending: 'warning',
};

const LABEL: Record<AllocationStatus, string> = {
    cancelled: 'Cancelled',
    checkedIn: 'Checked in',
    confirmed: 'Confirmed',
    pending: 'Pending',
};

interface Props {
    status: AllocationStatus;
}

export const StatusChip: React.FC<Props> = ({ status }) => {
    const label = LABEL[status];
    if (!label) return null;

    return (
        <IonChip color={COLOR[status]} className="ticket-used-chip">
            <IonLabel>{label}</IonLabel>
        </IonChip>
    );
};
